import { createContext } from "react";

// What the top bar's standard buttons do, provided once by NudgeApp: onAdd (the "Add new" sheet, the same on every
// page), onSearch, onNudges, onSettings, and onHome (the ◀ back to Home).
export const TopBarContext = createContext({});
